import { render } from "./Household.vue?vue&type=template&id=764d0986&scoped=true"
import script from "./Household.vue?vue&type=script&lang=js"
export * from "./Household.vue?vue&type=script&lang=js"

import "./Household.vue?vue&type=style&index=0&id=764d0986&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-764d0986"]])

export default __exports__